import { ChartTypeValue } from 'src/common/components/ChartTypeToggle/ChartTypeToggle';
import { UsageTypeValue } from 'src/common/components/UsageTypeSwitch/UsageTypeSwitch';

export const tariffSummaryGraphsQueries = {
  all: ['TariffSummaryGraphs'],
  subscriptionStatus: (filters: { accountRef: string; tariffCode: string | null }) => [
    ...tariffSummaryGraphsQueries.all,
    'Subscription Status',
    filters,
  ],
  cumulativeUsage: (filters: {
    accountRef: string;
    tariffCode: string;
    chartType: ChartTypeValue;
    usageType: UsageTypeValue;
  }) => [...tariffSummaryGraphsQueries.all, 'Cumulative Usage', filters],
};
